import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExtensionGuideDialogComponent } from './components/extension-guide-dialog/extension-guide-dialog.component';
import { ExtensionGuidePanelComponent } from './components/extension-guide-panel/extension-guide-panel.component';
import { ExtensionVisualLinkButtonComponent } from './components/visual-link-button/visual-link-button.component';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '../translate.module';
import { AngularSharedComponentsModule } from '@monsido/angular-shared-components';

@NgModule({
    declarations: [
        ExtensionGuideDialogComponent,
        ExtensionGuidePanelComponent,
        ExtensionVisualLinkButtonComponent,
    ],
    imports: [
        CommonModule,
        NgbTooltip,
        TranslateModule,
        AngularSharedComponentsModule,
    ],
    exports: [
        ExtensionGuideDialogComponent,
        ExtensionGuidePanelComponent,
        ExtensionVisualLinkButtonComponent,
    ],
})
export class ExtensionModule {}
